import { observer } from "mobx-react";
import type React from "react";

import { buildUrlWithPathParams } from "_helpers/utils/urlBuilder";
import { TEST_PAGE_ROUTES } from "constants/routes";
import type { DiagnosticTestPagePathParams } from "models/path/path-params";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import type { DiagnosticTestGroupItemProps } from "./DiagnosticTestGroupItem.model";
import { StyledDiagnosticTestGroupCard } from "./DiagnosticTestGroupItem.styled";

export const DiagnosticTestGroupItem: React.FC<DiagnosticTestGroupItemProps> = observer(
  ({ item, title = "", groupId }) => {
    const { productId, moduleId } = useParams() as unknown as DiagnosticTestPagePathParams;
    const navigate = useNavigate();
    const { t } = useTranslation("diagnostic-test");

    return (
      <StyledDiagnosticTestGroupCard
        title={title}
        dataCy={`diagnostic-test-group-item-${item.id}`}
        onClickButton={() =>
          navigate(
            buildUrlWithPathParams(TEST_PAGE_ROUTES.DIAGNOSTIC_TEST_LIST, {
              productId,
              moduleId,
              groupId,
            }),
          )
        }
        buttonLabel={t("diagnosticTestGroups.gotoTestsButton", "Go to tests")}
      />
    );
  },
);
